import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  debounceTime,
  distinctUntilChanged,
  EMPTY,
  Subject,
  switchMap,
} from "rxjs";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { FreightClientVendorSearchDto } from "../../../core/models/freight-quote/freightClientVendorSearchDto";
import { GetAllVendorsAndClientsDto } from "../../../core/models/samplePO/details/getAllVendorsAndClientsDto";
import { FreightQuoteService } from "../../../core/services/freight-quote.service";
import { AddressService } from "../../../core/services/address.service";
import { AddressCountryRegion } from "../../../core/models/shared/countryRegionList";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import {
  AutoComplete,
  AutoCompleteCompleteEvent,
  AutoCompleteModule,
  AutoCompleteSelectEvent,
} from "primeng/autocomplete";
import { TableModule } from "primeng/table";
import { Popover, PopoverModule } from "primeng/popover";
import { MelissaAddressResponseDto } from "../../../core/models/shared/mellssaAddressResponseDto";
import { MelissaAddressFormatResponseDto } from "../../../core/models/shared/melissaAddressFromatResponseDto";
import { RadioButtonModule } from "primeng/radiobutton";
import {
  ToggleSwitchChangeEvent,
  ToggleSwitchModule,
} from "primeng/toggleswitch";

@UntilDestroy()
@Component({
  selector: "jni-freight-addresses-form",
  templateUrl: "./freight-addresses-form.component.html",
  styleUrls: ["./freight-addresses-form.component.scss"],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SelectModule,
    AutoCompleteModule,
    TableModule,
    PopoverModule,
    RadioButtonModule,
    ToggleSwitchModule,
    FormsModule,
  ],
})
export class FreightAddressesFormComponent implements OnInit {
  public searchVendorAndClient$ = new Subject<{
    type: string;
    value: string;
    country: string;
  }>();
  showSmallLoader = false;
  @Input() countryRegionList: AddressCountryRegion[] = [];
  //clientList: any;
  @Input() saleOrderId = "";
  @Input() accountNumber = "";
  @Input() partyNumber = "";
  @Input() isShipment!: boolean;
  shiftToAddressField = "";
  address = ""; //toBeChangedIntoArray
  melissa = "";
  melissaStreet = "";
  appartmentFieldStatus = false;
  appartmentList: string[] = [];
  melissaSelection = "";
  selectedAppartment = "";
  formatResponse!: MelissaAddressFormatResponseDto;
  searchList!: FreightClientVendorSearchDto[];
  countryRegionSelectedId = "";
  IsResidential = false;
  @Input() formArray!: FormArray;
  formGroup!: FormGroup;
  isZipcodeSearch = false;
  isNumericSearch = false;
  //shiftToAddressList: any;
  addressSuggestions!: MelissaAddressResponseDto[];
  selectedAddressValue!: MelissaAddressResponseDto;

  @Input() shipmentReferenceId!: string;
  @Output() updateResidential = new EventEmitter<{
    check: boolean;
    type: string;
  }>();
  @Output() updateMetric = new EventEmitter<boolean>();
  @ViewChild("freightAddressPopover") freightAddressPopover!: Popover;
  selectedAddressIndex = 0;

  constructor(
    private _addressService: AddressService,
    private _freightQuoteService: FreightQuoteService
  ) {}

  ngOnInit(): void {
    this.searchClientAndVendor();
  }

  getFormGroup(index: number): FormGroup {
    return this.formArray.controls[index] as FormGroup;
  }

  toggleLocation(address: {
    value: {
      l: string;
      vendor: string;
      country: string;
      customer: string;
    };
  }): boolean {
    if (!address.value?.vendor && !address.value?.customer) {
      return true;
    } else {
      return false;
    }
  }

  onInputChange(
    index: number,
    event: KeyboardEvent,
    address: {
      value: {
        l: string;
        vendor: string;
        country: string;
        customer: string;
      };
    },
    drop: HTMLSpanElement
  ) {
    this.selectedAddressIndex = index;
    const target = event.target as HTMLInputElement;
    const input = target.value;
    if (
      (/^\d/.test(input) || address.value?.l) &&
      !address.value?.vendor &&
      !address.value?.customer
    ) {
      this.isNumericSearch = true;
      this.isZipcodeSearch = input.length === 5;
      this.countryRegionSelectedId = address.value.country;
    } else {
      this.isNumericSearch = false;
      const searchType = address.value.vendor
        ? "vendor"
        : address.value.customer
          ? "client"
          : "";
      this.searchVendorAndClient$.next({
        type: searchType,
        value: input,
        country: address.value.country,
      });
      this.onVendorSearchOpenToggle(drop, event);
    }
  }

  onViewAddresses(drop: HTMLSpanElement, address: AbstractControl) {
    this.isNumericSearch = false;
    const searchType =
      address.value.shipAddressType === "V"
        ? "vendor"
        : address.value.shipAddressType === "C"
          ? "client"
          : "";
    this.searchVendorAndClient$.next({
      type: searchType,
      value: address.value.shipAddressAccount,
      country: address.value.country,
    });
    const event = {
      target: {
        value: address.value.name,
      },
    };
    this.onVendorSearchOpenToggle(drop, event);
  }

  searchClientAndVendor() {
    this.searchVendorAndClient$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap(item => {
          this.showSmallLoader = true;
          const value = item.value;
          const type = item.type;
          const country = item.country;

          this.searchList = [];
          if (value != "" && value != undefined) {
            return this._freightQuoteService.searchClientAndVendor(
              value,
              type,
              country
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: (res: GenericResponseDto<FreightClientVendorSearchDto[]>) => {
          if (res.data != null) {
            this.searchList = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  onVendorSearchOpenToggle(
    mydrop: HTMLSpanElement | AutoComplete,
    event:
      | KeyboardEvent
      | {
          target: {
            value: string;
          };
        }
  ) {
    if ("target" in event && event.target) {
      const target = event.target as HTMLInputElement;
      if (target.value === "") {
        this.address = "";
      }
    }

    this.freightAddressPopover?.show(null, mydrop);
  }

  onVendorRowSelection(
    selectedRow: GetAllVendorsAndClientsDto,
    vendorToggle: Popover
  ) {
    this.showSmallLoader = true;
    const formGroup = this.formArray.at(this.selectedAddressIndex) as FormGroup;
    this.validateAddress(
      selectedRow.addressD365,
      selectedRow.country,
      formGroup,
      selectedRow,
      formGroup.value.type
    );
    vendorToggle.hide();
  }

  onVendorChange(index: number) {
    const formGroup = this.formArray.at(index) as FormGroup;
    //formGroup.reset();
    formGroup.patchValue({
      id: 0,
      name: "",
      formattedAddress: "",
      attention: "",
      address1: "",
      address2: "",
      address3: "",
      city: "",
      melissaKey: "",
      stateProvinceISO2: "",
      country: "USA",
      vendor: true,
      customer: false,
      shipAddressType: "V",
      l: false,
      isResidential: false,
      isAppartmentFieldStatus: false,
      postalCode: "",
    });
  }

  onCustomerChange(index: number) {
    const formGroup = this.formArray.at(index) as FormGroup;
    //formGroup.reset();
    formGroup.patchValue({
      id: 0,
      name: "",
      formattedAddress: "",
      attention: "",
      address1: "",
      address2: "",
      address3: "",
      city: "",
      melissaKey: "",
      stateProvinceISO2: "",
      country: "USA",
      vendor: false,
      customer: true,
      shipAddressType: "C",
      l: false,
      isResidential: false,
      isAppartmentFieldStatus: false,
      postalCode: "",
    });
  }

  onLocationChange(index: number) {
    const formGroup = this.formArray.at(index) as FormGroup;
    //formGroup.reset();
    formGroup.patchValue({
      id: 0,
      name: "",
      formattedAddress: "",
      attention: "",
      address1: "",
      address2: "",
      address3: "",
      city: "",
      melissaKey: "",
      stateProvinceISO2: "",
      country: "USA",
      vendor: false,
      customer: false,
      shipAddressType: "L",
      l: true,
      isResidential: false,
      postalCode: "",
    });
  }

  malisaFormatter = (result: MelissaAddressResponseDto | null | undefined) => {
    if (!result?.Address) return "";
    return this.isZipcodeSearch
      ? `${result.Address.Locality ?? ""} ${result.Address.PostalCode ?? ""} ${result.Address.CountryName ?? ""}`.trim()
      : (result.Address.Address ?? "");
  };

  searchMelissaAutoComplete(
    event: AutoCompleteCompleteEvent,
    addressType: {
      value: {
        l: string;
        vendor: string;
        country: string;
        customer: string;
      };
    }
  ) {
    if (
      !this.isNumericSearch &&
      !addressType.value?.vendor &&
      !addressType.value?.customer
    ) {
      return;
    }
    if (event.query === "") {
      this.addressSuggestions = [] as MelissaAddressResponseDto[];
    } else {
      try {
        if (this.isZipcodeSearch) {
          this._freightQuoteService
            .getMelissaDataByPostalCode(
              event.query,
              this.countryRegionSelectedId
            )
            .then((x: MelissaAddressResponseDto[]) => {
              this.addressSuggestions = x;
            });
        } else {
          this._addressService
            .getMelissaData(event.query, this.countryRegionSelectedId)
            .then((x: MelissaAddressResponseDto[]) => {
              this.addressSuggestions = x;
            });
        }
      } catch {
        this.addressSuggestions = [] as MelissaAddressResponseDto[];
      }
    }
  }

  removeAddressField() {
    this.melissaSelection = "";
    this.selectedAppartment = "";
  }

  selectedStreet(item: AutoCompleteSelectEvent) {
    const data = this.transformKeysToLower(item.value);
    if (!data.address.postalCode) {
      this.melissaSelection = "";
      return;
    }
    this.removeAddressField();
    const addressObj = data.address;
    let stateCode = "";
    if (addressObj.administrativeArea?.length <= 2) {
      stateCode = addressObj.administrativeArea as string;
    }
    this.appartmentList = [];
    const formGroup = this.formArray.at(this.selectedAddressIndex) as FormGroup;
    this._addressService
      .checkAddressValidation(
        data.address.address,
        this.countryRegionSelectedId
      )
      .subscribe(x => {
        const formatResponse = this.transformKeysToLower(x[0]);
        this.formatResponse = formatResponse;
        if (formatResponse) {
          if (this.isZipcodeSearch) {
            formGroup.patchValue({
              isResidential:
                addressObj.deliveryIndicator &&
                addressObj.deliveryIndicator === "R",
              melissaKey: addressObj.addressKey,
              address1: addressObj.addressLine1,
              address2: addressObj.addressLine2,
              address3: addressObj.addressLine3,
              city: addressObj.locality,
              stateProvinceISO2: stateCode,
              country: addressObj?.iSO3166_3,
              name: `${addressObj?.locality}, ${addressObj?.postalCode}, ${addressObj?.countryName}`,
              formattedAddress: [
                addressObj?.locality,
                addressObj?.postalCode,
                addressObj?.countryName,
              ]
                .filter(Boolean)
                .join(", "),
              shipAddressType: "L",
              postalCode: addressObj.postalCode,
            });
          } else {
            formGroup.patchValue({
              isResidential:
                formatResponse.deliveryIndicator &&
                formatResponse.deliveryIndicator === "R",
              melissaKey: formatResponse.addressKey,
              address1: formatResponse.addressLine1,
              address2: formatResponse.addressLine2,
              address3: formatResponse.addressLine3,
              city: formatResponse.locality,
              stateProvinceISO2: stateCode,
              country: formatResponse?.countryISO3166_1_Alpha3,
              name: formatResponse.formattedAddress || "",
              formattedAddress: [
                formatResponse?.addressLine1,
                formatResponse?.addressLine2,
                formatResponse?.addressLine3,
              ]
                .filter(Boolean)
                .join(", "),
              shipAddressType: "L",
              postalCode: formatResponse.postalCode,
            });
          }
        }
      });

    if (addressObj.subBuilding) {
      this.appartmentList = (addressObj.subBuilding as string).split(",");
      formGroup.patchValue({
        isAppartmentFieldStatus: true,
      });
    } else {
      if (formGroup.value.isAppartmentFieldStatus) {
        formGroup.patchValue({
          isAppartmentFieldStatus: false,
        });
      }
    }
    this.melissaSelection = `${addressObj.address1}, ${addressObj.address2}, ${addressObj.address3}`;
  }

  onAppartmentSelection(event: string, index: number) {
    let fullAddress = this.melissaSelection;
    if (event !== "") {
      const splitSelected = fullAddress.split(",");
      if (splitSelected.length > 0) {
        splitSelected[0] += `, ${event}`;
        fullAddress = splitSelected.filter(Boolean).join(", ");
      }
    }
    const formGroup = this.formArray.at(index) as FormGroup;
    formGroup.patchValue({
      formattedAddress: fullAddress,
    });
  }

  validateAddress(
    address: string,
    country: string,
    formGroup: FormGroup,
    selectedRow: GetAllVendorsAndClientsDto,
    type: string
  ) {
    this.showSmallLoader = true;

    if (
      //OSCustom
      formGroup.value.shipAddressType === "V" ||
      formGroup.value.shipAddressType === "C"
    ) {
      formGroup.patchValue({
        type: type,
        country: selectedRow.country,
        name: selectedRow.shipToName,
        formattedAddress: selectedRow?.addressD365?.replace(/\n/g, " ") || "", // Replace \n with space,
        attention: selectedRow.billingAttentionD365,
        address1: selectedRow.streetD365,
        address2: "",
        address3: "",
        city: selectedRow.city,
        melissaKey: "",
        stateProvinceISO2: selectedRow.state,
        vendor: selectedRow.isVendor,
        customer: selectedRow.isClient,
        shipAddressType: selectedRow.isVendor ? "V" : "C",
        shipAddressAccount: selectedRow.isVendor
          ? selectedRow.vendorAccountNumber
          : selectedRow?.clientAccount,
        l: false,
        isResidential: selectedRow.isResidential,
        postalCode: selectedRow.zipCodeD365,
        isAppartmentFieldStatus: false,
      });
    } else {
      this._addressService
        .checkAddressValidation(address, country)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res) {
              const validateAddress = this.transformKeysToLower(res[0]);
              let address = "";
              if (validateAddress) {
                address = [
                  validateAddress?.addressLine1,
                  validateAddress?.addressLine2,
                  validateAddress?.addressLine3,
                ]
                  .filter(Boolean)
                  .join(", ");
              }

              formGroup.patchValue({
                type: type,
                country: selectedRow.country,
                name: selectedRow.shipToName,
                formattedAddress: address ? address : selectedRow.addressD365,
                attention: selectedRow.billingAttentionD365,
                address1: "",
                address2: "",
                address3: "",
                city: selectedRow.city,
                melissaKey: "",
                stateProvinceISO2:
                  validateAddress?.administrativeArea || selectedRow.postalCode,
                vendor: selectedRow.isVendor,
                customer: selectedRow.isClient,
                shipAddressType: selectedRow.isVendor ? "V" : "C",
                shipAddressAccount: selectedRow.isVendor
                  ? selectedRow.vendorAccountNumber
                  : selectedRow?.clientAccount,
                l: false,
                isResidential: selectedRow.isResidential,
                postalCode:
                  validateAddress?.postalCode || selectedRow.postalCode,
                isAppartmentFieldStatus: false,
              });
            } else {
              return;
            }
          },
        });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transformKeysToLower(obj: MelissaAddressFormatResponseDto): any {
    if (!obj || typeof obj !== "object") return obj;

    if (Array.isArray(obj)) {
      return obj.map(item => this.transformKeysToLower(item));
    }

    return Object.keys(obj).reduce((acc, key) => {
      const newKey = (key.charAt(0).toLocaleLowerCase() +
        key.slice(1)) as keyof MelissaAddressFormatResponseDto;
      const value = obj[
        key as keyof MelissaAddressFormatResponseDto
      ] as unknown as MelissaAddressFormatResponseDto;

      acc[newKey] = this.transformKeysToLower(value);

      return acc;
    }, {} as MelissaAddressFormatResponseDto);
  }

  handleResidential(event: ToggleSwitchChangeEvent, type: string) {
    const orignalEvent = event.originalEvent;
    const checked = (orignalEvent.target as HTMLInputElement).checked;
    this.updateResidential.emit({ check: checked, type: type });
  }

  countryChange(country: string, type: string) {
    if (country.toLowerCase() !== "usa" && type.toLowerCase() === "from") {
      this.updateMetric.emit(true);
    }
  }
}
